/*
 * @params {string} resource
 * @params {array} values, na mesma ordem das variáveis da string
 *
 * ex: "Essa parada tem %s pedidos, vindos de %s stops, que totalizam %f kilos e foram emitidos em %D"
 *
 * [String, String, Decimal Float, Date]
 *
 */

Monet.I18n = {

    locale: {},

    resources: {},

    translateInterface: function () {

        /*
         * Pesca jquery
         *
         * por ID $("#page_container")
         *
         * por class $(".i18nResource")
         *
         * por estrutura mais complexa: $(".ui-tabs-nav li a")
         *
         */

        var that = this;

        //buscando os labels do pagelayout
        $.each($(".i18nResource"), function (index, elementToTranslate) {

            that.getResourceValues(elementToTranslate);

        });

        //buscando os botoes do pagelayout
        $.each($(".ui-tabs-nav li a"), function (index, elementToTranslate) {

            that.getResourceValues(elementToTranslate);

        });

        //buscando os elementos options de um select(combo box) do pagelayout
        $.each($("option.i18nResource"), function (index, elementToTranslate) {

            that.getResourceValues(elementToTranslate);

        });

        //buscando os elementos do submenu
        $.each($(".nav li ul#menu1 li a"), function (index, elementToTranslate) {

            var translatedResource = "";
            var resourceKey = "";
            var htmlHeader = "";
            var innerHMTL;

            innerHMTL = elementToTranslate.innerHTML.toLocaleLowerCase();

            resourceKey = elementToTranslate.innerHTML.substring(0, innerHMTL.indexOf("<i class"));

            htmlHeader = elementToTranslate.innerHTML.substring(innerHMTL.indexOf("<i class"));

            if (resourceKey !== "") {

                translatedResource = Monet.I18n.getResourcesByKey(resourceKey);

                if (typeof (translatedResource) !== "undefined") {
                    elementToTranslate.innerHTML = translatedResource + htmlHeader;
                }

            }

        });

        $.each($("li[librarycheckid] a"), function (index, elementToTranslate) {
            var html = elementToTranslate.innerHTML;
            var resKey = html.substring(html.indexOf("/ins>") + 5);
            var value = Monet.I18n.getResourcesByKey(resKey);

            if (value !== undefined) {
                html = html.replace(resKey, value);
                elementToTranslate.innerHTML = html;
            }
        });

        $.each($("li[libraryactionid] a"), function (index, elementToTranslate) {
            var html = elementToTranslate.innerHTML;
            var resKey = html.substring(html.indexOf("/ins>") + 5);
            var value = Monet.I18n.getResourcesByKey(resKey);

            if (value !== undefined) {
                html = html.replace(resKey, value);
                elementToTranslate.innerHTML = html;
            }
        });

        $.each($("li[libraryid] a"), function (index, elementToTranslate) {
            var html = elementToTranslate.innerHTML;
            var resKey = html.substring(html.indexOf("/ins>") + 5);
            var value = Monet.I18n.getResourcesByKey(resKey);

            if (value !== undefined) {
                html = html.replace(resKey, value);
                elementToTranslate.innerHTML = html;
            }
        });

        //buscando os elementos do menu
        $.each($(".nav li a"), function (index, elementToTranslate) {

            that.getResourceValues(elementToTranslate);

        });

        //buscando os elementos do dropdwond de lingua
        $.each($("a.ui-corner-all"), function (index, elementToTranslate) {

            that.getResourceValues(elementToTranslate);

        });

        $.each($(".qtip-title"), function (index, elementToTranslate) {
            $(elementToTranslate).html(Monet.I18n.getResourcesByKey($(elementToTranslate).html()));
        });

        $.each($("[i18nKey]"), function (index, elementToTranslate) {
            elementToTranslate.setAttribute ('text', Monet.I18n.getResourcesByKey (elementToTranslate.getAttribute ('i18nKey')));
        });

        $("div[action=previous]").html(Monet.I18n.getResourcesByKey("Grid.pagination.previous"));
        $("div[action=next]").html(Monet.I18n.getResourcesByKey("Grid.pagination.next"));

        that = null;

    },

    getResourceValues: function (elementToTranslate) {

        var translation = "",
            placeHolder = "";

        function trim(text) {
            const textChecked = String.prototype.trim.call( text == null ? "" : text );
            return textChecked.trim();
        }
    

        switch (elementToTranslate.tagName) {
            case "INPUT":

                translation = Monet.I18n.getResourcesByKey ($(elementToTranslate).val());

                placeHolder = Monet.I18n.getResourcesByKey ($(elementToTranslate).attr("placeholder"));

                //analisa se o tipo do botao est√° definido
                if (typeof (translation) !== "undefined") {
                    $(elementToTranslate).val(translation);

                }

                if (typeof(placeHolder) !== "undefined") {
                    $(elementToTranslate).attr("placeholder", placeHolder);
                }
                break;

            case "SPAN":

                //analisa se o tipo do elemento html est√° definido
                translation = Monet.I18n.getResourcesByKey($(elementToTranslate).html());

                if (typeof (translation) !== "undefined") {

                    if (translation.match(/{.*}/) !== null) {

                        Monet.I18n.changeResource(translation, elementToTranslate);

                    } else {

                        $(elementToTranslate).html(translation);

                    }
                }
                break;

            case "DIV":

                //analisa se o tipo do elemento html est√° definido
                translation = Monet.I18n.getResourcesByKey ($(elementToTranslate).html().trim());

                if (typeof (translation) !== "undefined") {
                    $(elementToTranslate).html(translation);
                }
                break;

            case "A":

                //analisa se o tipo do elemento html est√° definido
                translation = Monet.I18n.getResourcesByKey (trim($(elementToTranslate).html()));

                if (typeof (translation) !== "undefined") {
                    $(elementToTranslate).html(translation);
                }
                break;

            case "OPTION":

                //analisa se o tipo do elemento html est√° definido
                translation = Monet.I18n.getResourcesByKey(trim($(elementToTranslate).html()));

                if (typeof (translation) !== "undefined") {
                    $(elementToTranslate).html(translation);
                }
                break;

            default:
                $(elementToTranslate).html(Monet.I18n.getResourcesByKey (trim($(elementToTranslate).html())));
                break;
        }
    },

    clearUserData: function () {
        Monet.I18n.locale = {};
        Monet.I18n.resources = {};
    },

    checkResources: function () {

        if (Monet.I18n.locale !== null && typeof(Monet.I18n.locale.id) === "undefined") {
            Monet.I18n.getFullData();
        }

        Monet.I18n.translateInterface();

    },

    changeResource: function (translation, elementToTranslate) {

        var originalTranslate = Monet.I18n.getResourcesByKey($(elementToTranslate).html());
        var miolo = translation.match(/{.*}/);
        var key = miolo[0].replace("{", "").replace("}", "");

        if (key === "distance") {

            if (Monet.Session.User !== undefined && Monet.Session.User["unitSystem"] !== "METRIC") {
                translation = originalTranslate.replace(
                    "{" + key + "}",
                    Monet.I18n.getResourcesByKey("UnitSystems.Miles.abbreviation"
                    ));
            } else {
                translation = originalTranslate.replace(
                    "{" + key + "}",
                    Monet.I18n.getResourcesByKey("UnitSystems.Meters.abbreviation"
                    ));
            }

        } else {
            translation = originalTranslate.replace("{" + key + "}", Monet.Session.Configurations[key]);
        }


        $(elementToTranslate).html(translation);

    },

    getResource: function () {

        if (Monet.I18n.locale !== null && typeof Monet.I18n.locale.id !== "undefined") {

            Monet.Session.ApplicationLoad.resources.forEach(function (resource) {
                Monet.I18n.resources[resource.key.trim().toLowerCase()] = resource.value;
            });

            this.createDatePikerTranslates();
            Greenmile.Datepicker.LocationFormat();

        }

    },

    getLocales: function () {
        if (Monet.Session.isLogged && Monet.Session.ApplicationLoad.loggedUser) {
            Monet.I18n.locale = Monet.Session.ApplicationLoad.loggedUser.preferedLocale;
            Monet.I18n.locale.dateFormat = Monet.I18n.locale.dateFormat.toUpperCase();
            Monet.I18n.locale.dateTimeFormat = Monet.I18n.locale.dateFormat + ' ' + Monet.I18n.locale.timeFormat;
            this.getResource();
        }
    },

    getFullData: function () {

        Monet.I18n.getLocales();

    },

    getResourcesByKey: function (key, valueInResource) {

        var value;

        if(key && key.toLowerCase) {
            value = Monet.I18n.resources[key.toLowerCase()];
        }

        if (value) {
            return this.translateResourceSizes (value, valueInResource);
        }

        return key;
    },

    translateResourceSizes: function(resource, valueInResource) {

        var translation = resource;

        if (resource.match(/{.*}/) !== null) {

            var miolo = resource.match(/{.*}/),
                key = miolo[0].replace("{", "").replace("}", "");

            if (valueInResource) {
                translation = resource.replace("{" + key + "}", valueInResource);
            } else {
                translation = resource.replace("{" + key + "}", Monet.Session.Configurations[key]);
            }
        }

        return translation;
    },

    translateResources: function (key, params) {
        var resourceValue = Monet.I18n.resources[key.trim().toLowerCase()];
        if(resourceValue && params){
            for(var i in params){
                resourceValue = resourceValue.replace('{'+ i +'}', params[i]);
            }
            return resourceValue;
        } else {
            return key;
        }

    },

    replaceParamsInResource: function replaceParamsInResource(resourceValue, params) {
			if (resourceValue && params) {
				for (var i in params) {
					resourceValue = resourceValue.replace('{' + i + '}', params[i]);
				}
				return resourceValue;
			} else {
				return resourceValue;
			}
		},

    createDatePikerTranslates: function () {

        moment.locale(Monet.I18n.locale.language);
        $.timepicker.regional[Monet.I18n.locale.language] = {
            timeOnlyTitle: 'Choose Time',
            timeText: Monet.I18n.getResourcesByKey("DateTimePicker.Time"),
            hourText: Monet.I18n.getResourcesByKey("DateTimePicker.Hour"),
            minuteText: Monet.I18n.getResourcesByKey("DateTimePicker.Minute"),
            secondText: Monet.I18n.getResourcesByKey("DateTimePicker.Second"),
            millisecText: 'Millisecond',
            timezoneText: 'Time Zone',
            currentText: Monet.I18n.getResourcesByKey("DateTimePicker.Now"),
            closeText: Monet.I18n.getResourcesByKey("DateTimePicker.Done"),
            timeFormat: 'hh:mm',
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P']
        };

        $.timepicker.setDefaults($.timepicker.regional[Monet.I18n.locale.language]);

    },

    addResource: function(key, value) {
        Monet.I18n.resources[key.trim().toLowerCase()] = value;
    }

};
